import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=552a7b8f&scoped=true"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationPage.vue?vue&type=style&index=0&id=552a7b8f&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a7b8f",
  null
  
)

export default component.exports